import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrafficLightModule } from '@app/pcs/shared/components/traffic-light/traffic-light.module';
import {
  CarryForwardColumnComponent
} from '@app/pcs/shared/containers/search-results-grid/carry-forward-column.component';
import {
  DossierSearchGridComponent
} from '@app/pcs/shared/containers/search-results-grid/dossier-search-grid.component';
import {
  CustomNumberFilterComponent
} from '@app/pcs/shared/containers/search-results-grid/filters/custom-number-filter.component';
import {
  CustomTextFilterComponent
} from '@app/pcs/shared/containers/search-results-grid/filters/custom-text-filter.component';
import {
  MultiSelectGridFilterComponent
} from '@app/pcs/shared/containers/search-results-grid/filters/multi-select-grid-filter.component';
import {
  SingleSelectGridFilterComponent
} from '@app/pcs/shared/containers/search-results-grid/filters/single-select-grid-filter.component';
import { GridLabelsComponent } from '@app/pcs/shared/containers/search-results-grid/labels/grid-labels.component';
import { LabelsColumnComponent } from '@app/pcs/shared/containers/search-results-grid/labels-column.component';
import { LabelsFilterComponent } from '@app/pcs/shared/containers/search-results-grid/labels-filter.component';
import {
  ObservationTypesColumnComponent
} from '@app/pcs/shared/containers/search-results-grid/observation-types-column.component';
import {
  ObservationTypesFilterComponent
} from '@app/pcs/shared/containers/search-results-grid/observation-types-filter.component';
import {
  TrafficLightsColumnComponent
} from '@app/pcs/shared/containers/search-results-grid/traffic-lights-column.component';
import {
  TrafficLightsExtendedColumnComponent
} from '@app/pcs/shared/containers/search-results-grid/traffic-lights-extended-column.component';
import {
  TrafficLightsListColumnComponent
} from '@app/pcs/shared/containers/search-results-grid/traffic-lights-list-column.component';
import {
  ExcelExportOptionsModule
} from '@app/pcs/shared/export-options/excel-export-options/excel-export-options.module';
import { PdfExportOptionsModule } from '@app/pcs/shared/export-options/pdf-export-options/pdf-export-options.module';
import { LabelModule } from '@app/pcs/shared/labels/label/label.module';
import { LabelSelectionModule } from '@app/pcs/shared/labels/label-selection/label-selection.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    TrafficLightModule,
    PdfExportOptionsModule,
    ExcelExportOptionsModule,
    LabelSelectionModule,
    LabelModule
  ],
  declarations: [
    DossierSearchGridComponent,
    TrafficLightsColumnComponent,
    TrafficLightsListColumnComponent,
    TrafficLightsExtendedColumnComponent,
    CarryForwardColumnComponent,
    LabelsColumnComponent,
    LabelsFilterComponent,
    GridLabelsComponent,
    ObservationTypesColumnComponent,
    SingleSelectGridFilterComponent,
    CustomTextFilterComponent,
    MultiSelectGridFilterComponent,
    CustomNumberFilterComponent,
    ObservationTypesFilterComponent
  ],
  exports: [
    DossierSearchGridComponent
  ]
})
export class DossierSearchGridModule {
}
